import React from 'react';

/* ============================================================================
   MenuToggleIcon — 21st.dev "menu-toggle-icon" uyarlaması
   ----------------------------------------------------------------------------
   Kaynak bileşen TypeScript + `cn()` yardımcısıyla yazılmıştı; bu proje saf
   JavaScript olduğu için sınıf birleştirme düz şablon dizesiyle yapıldı
   (clsx paketi projede var ama tek bir koşullu sınıf için bağımlılık
   eklemenin anlamı yok).

   NASIL ÇALIŞIYOR
   Tek bir `path` var ve bu path aslında "üst çubuk → sağa dönen kanca →
   dikey gövde → sola dönen kanca → alt çubuk" şeklinde uzun bir çizgi.
   Kapalı durumda `stroke-dasharray: 12 63` uygulanıyor: 12 birim çiziliyor,
   63 birim boşluk bırakılıyor — böylece yalnızca üst ve alt çubuk görünüyor,
   arada kalan kanca+gövde boşlukta kalıyor.
   Açık durumda `stroke-dasharray: 20 300` + `stroke-dashoffset: -32.42px`
   uygulanıyor: desen kaydırılıyor ve tek bir 20 birimlik kesintisiz çizgi
   ortaya çıkıyor. Aynı anda tüm SVG -45° dönüyor; sabit duran orta çizgiyle
   (`M7 16 27 16`) birlikte çarpı (X) oluşuyor.

   TAILWIND NOTU — ÖLÇÜLDÜ
   Tailwind 3.4.17 ile `[stroke-dasharray:12_63]`, `[stroke-dasharray:20_300]`,
   `[stroke-dashoffset:-32.42px]` ve
   `[transition-property:stroke-dasharray,stroke-dashoffset]` sınıflarının
   dördü de üretiliyor (tailwindcss CLI çıktısıyla doğrulandı), bu yüzden
   App.css'e yedek `.wh-menu-*` sınıfları yazmaya gerek kalmadı.

   PERFORMANS
   `stroke-dasharray` geçişi boyama (paint) katmanında çalışır, compositor'da
   değil. Bu kabul edilebilir: hareket 32x32 piksellik tek bir ikonla sınırlı
   ve yalnızca kullanıcı dokunduğunda, saniyede bir kereden az tetikleniyor.
   Navbar'ın kaydırma sırasında sürekli çalışan hiçbir parçası bu özelliği
   kullanmıyor.
   ========================================================================= */

export default function MenuToggleIcon({
  acik = false,
  /* Referans bileşenin varsayılanı 500ms. */
  sure = 500,
  boyut = 22,
  className = '',
}) {
  const gecis = { transitionDuration: `${sure}ms` };

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={boyut}
      height={boyut}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={gecis}
      className={`transition-transform ease-in-out ${acik ? '-rotate-45' : 'rotate-0'} ${className}`}
    >
      <path
        style={gecis}
        className={`[transition-property:stroke-dasharray,stroke-dashoffset] ease-in-out ${
          acik
            ? '[stroke-dasharray:20_300] [stroke-dashoffset:-32.42px]'
            : '[stroke-dasharray:12_63] [stroke-dashoffset:0px]'
        }`}
        d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
      />
      <path d="M7 16 27 16" />
    </svg>
  );
}
